<template>
  <v-app-bar height="50" dense elevation="1" fixed app clipped-left style="background-color: black">
    <v-btn
      v-if="sidebar"
      small
      fab
      text
      @click.stop="toggleDrawer"
    >
      <v-icon color="white">mdi-menu</v-icon>
    </v-btn>
    <v-toolbar-title class="mr-3">
      <router-link to="/" tag="span" style="cursor: pointer">
        <img
          alt="logo"
          class="text-center d-flex align-center"
          style="width: 120px"
          src="@/assets/images/logo-active.svg"
        />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-md-and-down">
      <v-btn depressed text link href="/home" small>
        <v-icon left color="white"> mdi-home</v-icon>
        <span class="white--text">Inicio</span>
      </v-btn>

      <v-menu v-if="hasPermission(permissions.users.read)" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed text small v-bind="attrs" v-on="on">
            <v-icon left color="white"> mdi-cog-outline</v-icon>
            <span class="white--text">Configuración</span>
          </v-btn>
        </template>
        <v-list style="background-color: black">
          <v-list-item to="/usuarios">
            <v-list-item-title class="white--text">Usuarios</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y v-if="hasPermission(permissions.project.read)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed text small v-bind="attrs" v-on="on">
            <v-icon left color="white"> mdi-alien-outline</v-icon>
            <span class="white--text">Operaciones</span>
          </v-btn>
        </template>
        <v-list color="primary">
          <v-list-item to="/proyectos">
            <v-list-item-title class="white--text">Proyectos</v-list-item-title>
          </v-list-item>
          <v-list-item to="/ordenes?tab=0">
            <v-list-item-title class="white--text">Ordenes</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y v-if="canShowCommercialItem">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed text small v-bind="attrs" v-on="on">
            <v-icon left color="white"> mdi-account-tie-voice</v-icon>
            <span class="white--text">Comercial</span>
          </v-btn>
        </template>
        <v-list style="background-color: black">
          <v-list-item
            v-if="canViewQuotes"
            to="/cotizaciones?tab=0"
          >
            <v-list-item-title class="white--text">Cotizaciones</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasPermission(permissions.rates.showPrices)"
            to="/tarifas"
          >
            <v-list-item-title class="white--text">Tarifas</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="hasPermission(permissions.invoiceSwo.read) || hasPermission(permissions.invoicePwo.read)"
            to='/facturas'
          >
            <v-list-item-title class="white--text">Prefacturas</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            text
            small
            class="text-capitalize"
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar class="mr-2" size="30">
              <v-img :src="authUser.picture"></v-img>
            </v-avatar>
            <div v-if="authUser" class="white--text">{{ authUser.firstName }}</div>
          </v-btn>
        </template>
        <v-list tile dense style="background-color: black">
          <v-list-item link>
            <v-list-item-title @click="logout" class="white--text"> Salir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import MENU_ITEMS_CONSTANTS from '@/constants/MenuItemsConstants'
import PERMISSIONS from '../../constants/PermissionConstants'
import sessionMixin from '../../mixins/sessionMixin'
import { AUTH_URL } from '@/constants/ServicesConstants'
import errorHandlerMixin from '../../mixins/errorHandlerMixin'
import notificationMixin from '../../mixins/notificationMixin'
import loaderMixin from '../../mixins/loaderMixin'
import crudServiceMixin from '../../mixins/crudServiceMixin'

export default {
  name: 'Header',
  data () {
    return {
      menuItems: MENU_ITEMS_CONSTANTS,
      permissions: PERMISSIONS
    }
  },
  props: {
    sidebar: {
      type: Boolean
    }
  },
  computed: {
    authUser () {
      return this.getAuthUser()
    },
    canShowCommercialItem () {
      return (
        this.hasPermission(this.permissions.rates.read) ||
        this.hasPermission(this.permissions.projectQuotes.read) ||
        this.hasPermission(this.permissions.staffQuotes.read)
      )
    }
  },
  mixins: [
    sessionMixin,
    errorHandlerMixin,
    loaderMixin,
    crudServiceMixin,
    notificationMixin
  ],
  methods: {
    toggleDrawer () {
      this.$emit('toggleDrawer')
    },
    async logout () {
      try {
        this.showLoader()
        await this.post(AUTH_URL + '/logout', {
          token: this.authUser.token
        })
        this.clear()
        await this.$router.push({ path: '/' })
        this.hideLoader()
      } catch (e) {
        this.errorHandler(e)
        this.hideLoader()
      }
    },
    canViewQuotes () {
      return this.hasPermission(this.permissions.projectQuotes.read) || this.hasPermission(this.permissions.staffQuotes.read) ||
        this.hasPermission(this.permissions.projectQuotes.readAll) || this.hasPermission(this.permissions.staffQuotes.readAll)
    }
  }
}
</script>
